import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import store from './redux/store';
import { ConfigProvider } from 'antd';
import 'antd/dist/reset.css';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import { ToastProvider } from './components/ToastContext';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastProvider>
        <HashRouter>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: '#0055B8', // From logo - unified with design tokens
                colorLink: '#0055B8',
                colorLinkHover: '#2B7DD4',
                borderRadius: 8,
              },
            }}
          >
            <App />
          </ConfigProvider>
        </HashRouter>
      </ToastProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
